import { createContext, useContext, useState, useEffect } from "react";

export const AuthContext = createContext({
    user: null,
    updateUser: (newUser) => { }
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem("authUser");
        return storedUser ? JSON.parse(storedUser) : null;
    });

    const updateUser = (newUser) => {
        setUser(newUser);
        sessionStorage.setItem("authUser", JSON.stringify(newUser))
    }



    return (
        <AuthContext.Provider value={{ user, updateUser }}>
            {children}
        </AuthContext.Provider >
    );
}

